
import { AssetType } from '../../assettype/model/asset-type.model';
import { ELECTRICAL_ASPECT_METADATA } from './electrical-aspect.metadata';
import { ElectricalAspectBase } from './electrical-aspect.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface ElectricalAspect extends ElectricalAspectBase {
}

export interface ElectricalAspectTransient { }

export class ElectricalAspect extends CrudEntity<ElectricalAspect, number, ElectricalAspectTransient> implements ElectricalAspectTransient {
  constructor(source?: Partial<ElectricalAspect>, options?: CrudEntityConstructionOptions<ElectricalAspect, number, ElectricalAspectTransient>) {
    super(ELECTRICAL_ASPECT_METADATA, source, options);
  }

  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }

  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }

  setDefaultsForAssetType(assetType: AssetType) {
    if (assetType != null) {
      this.portableApplianceTestingDays = assetType.portableApplianceTestingDays;
    }
  }

  get aspectAssetId() {
    return null;
  }
}





